import styled from 'styled-components'

const StyledShareDrawer = styled.div`
  
`

export default StyledShareDrawer
